import { render, staticRenderFns } from "./UniSearch.vue?vue&type=template&id=5123b88d&"
import script from "./UniSearch.vue?vue&type=script&lang=js&"
export * from "./UniSearch.vue?vue&type=script&lang=js&"
import style0 from "./UniSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports